<template>
  <div class="error-container">
    <div class="error-card">
      <h2 class="error-title">{{ errorNb }}</h2>
      <img
        class="error-image"
        src="@/assets/images/AngryCat.jpg"
        alt="Angry Cat"
        v-tooltip="'www.vecteezy.com'"
      />
      <div class="error-body">
        <p class="error-card-title">
          {{ title }}
        </p>
        <p class="error-card-subtitle">
          {{ subtitle }}
        </p>
        <PrimeButton
          icon="ri-corner-down-left-line"
          :label="$t('goHome')"
          class="error-button"
          @click="onClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "primevue/button";

export default {
  name: "ErrorComponent",
  components: {
    PrimeButton: Button,
  },
  props: {
    errorNb: {
      type: String,
      default: "500",
    },
    homeName: {
      type: String,
      default: "welcome",
    },
  },
  data() {
    return {
      title: "",
      subtitle: "",
    };
  },
  created() {
    this.title = this.$t("nothingTitle");
    this.subtitle = this.$t("nothingText");
  },
  methods: {
    onClick() {
      this.$router.push({
        name: this.homeName,
      });
    },
  },
};
</script>

<style scoped>
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

.error-card {
  max-width: 25rem;
  margin: 1.25rem;
  padding: 1.25rem;
  border: 1px solid var(--p-content-border-color);
  border-radius: var(--p-border-radius);
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.1);
  background-color: var(--p-surface-card);
  text-align: center;
}

.error-title {
  font-size: 5rem;
  font-weight: bold;
  margin-bottom: 0.625rem;
  color: var(--p-text-color, #333);
}

.error-image {
  width: 100%;
  border-radius: 0.5rem;
}

.error-body {
  padding-top: 1rem;
}

.error-card-title {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 0.3125rem;
  color: var(--p-text-color, #333);
}

.error-card-subtitle {
  font-size: 1.2rem;
  color: var(--p-text-muted-color, #666);
  margin-bottom: 0.9375rem;
}

.error-button {
  width: 100%;
  font-weight: bold;
}
</style>
